import { render, staticRenderFns } from "./DeliveredModal.vue?vue&type=template&id=7c38037d&"
import script from "./DeliveredModal.vue?vue&type=script&lang=js&"
export * from "./DeliveredModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports